import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import ClientsTemplate from '@components/Clients/Clients';
import CompanyValuesTemplate from '@components/CompanyValues/CompanyValues';
import CustomersTemplate from '@components/Customers/Customers';
import EducationTemplate from '@components/Education/Education';
import FooterTemplate from '@components/Footer/Footer';
import GalleryTemplate from '@components/Gallery/Gallery';
import HeaderTemplate from '@components/Header/Header';
import TrainingTypesTemplate from '@components/TrainingTypes/TrainingTypes';
import useTranslation from '@hooks/useTranslation';
import HeroTemplate from '@ui/Hero/Hero';
import { IS_PROD } from '../constants';

interface IAboutUs {}

const AboutUs: NextPage<IAboutUs> = () => {
    const { t } = useTranslation();

    return (
        <>
            <NextSeo title={t('seo.about.title')} description="" noindex={!IS_PROD} nofollow={!IS_PROD} />
            <HeaderTemplate />
            <HeroTemplate
                titleKey="about.hero.title"
                imageKey="about_hero.webp"
                descriptionKey="about.hero.paragraph"
            />
            <CompanyValuesTemplate />
            <TrainingTypesTemplate />
            <EducationTemplate />
            <GalleryTemplate />
            <CustomersTemplate />
            <ClientsTemplate titleKey={'about.partners.title'} showPartners />
            <FooterTemplate />
        </>
    );
};

export default AboutUs;
